/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Sex_MaleInputs */

const en_us2_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Men`)
};

const pt_br2_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homens`)
};

const es_419_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hombres`)
};

const pt_pt2_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homens`)
};

const fr_fr2_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hommes`)
};

const de_de2_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Männer`)
};

const it_it2_exercise_personal_strength_sex_male = /** @type {(inputs: Exercise_Personal_Strength_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uomini`)
};

/**
* | output |
* | --- |
* | "Men" |
*
* @param {Exercise_Personal_Strength_Sex_MaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_sex_male = /** @type {((inputs?: Exercise_Personal_Strength_Sex_MaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Sex_MaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_sex_male(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_sex_male(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_sex_male(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_sex_male(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_sex_male(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_sex_male(inputs)
	return en_us2_exercise_personal_strength_sex_male(inputs)
});
export { exercise_personal_strength_sex_male as "exercise-personal.strength_sex_male" }